/**
 * Parses a single CSV line into an array of values
 * Handles quoted fields and escaped quotes (double quotes)
 * @param {string} line - The CSV line to parse
 * @returns {Array<string>} Array of parsed field values
 */
const parseCSVLine = (line) => {
  const result = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) {
      result.push(current);
      current = "";
    } else {
      current += char;
    }
  }

  result.push(current);
  return result;
};

/**
 * Reads and parses a CSV file
 * @param {File} file - The CSV file to read
 * @returns {Promise<{headers: Array<string>, rows: Array<Array<string>>}>}
 *          Object containing headers array and rows array (2D array of values)
 * @throws {Error} If file reading fails
 */
export const ReadCSV = async (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = (e) => {
      const csvData = e.target.result;
      const lines = csvData.split("\n").filter((line) => line.trim());

      if (lines.length === 0) {
        resolve({ headers: [], rows: [] });
        return;
      }

      const headers = parseCSVLine(lines[0]);
      const rows = [];

      for (let i = 1; i < lines.length; i++) {
        const columns = parseCSVLine(lines[i]);
        if (columns[0]?.trim()) {
          rows.push(columns.map((col) => col.trim()));
        }
      }

      resolve({ headers, rows });
    };
    fileReader.onerror = (error) => {
      reject(new Error(error));
    };
  });
};

